import request from '@/utils/server'
// 新增内部订单
export function add(data) {
    return request({
      url: '/order/add',
      method: 'POST',
      data:data
    })
  }
//   删除订单
export function delOrder(data) {
    return request({
      url: '/order/delOrder',
      method: 'POST',
      data:data
    })
  }
//   修改订单
export function edit(data) {
    return request({
      url: '/order/edit',
      method: 'POST',
      data:data
    })
  }
//   新增商品订单
export function addOrderItem(data) {
    return request({
      url: '/order/addOrderItem',
      method: 'POST',
      data:data
    })
  }
//   修改商品订单
export function editOrderItem(data) {
    return request({
      url: '/order/editOrderItem',
      method: 'POST',
      data:data
    })
  }
//   删除订单商品
export function delOrderItem(data) {
    return request({
      url: '/order/delOrderItem',
      method: 'POST',
      data:data
    })
  }
  // 接单
  export function createPurchasePlan(data) {
    return request({
      url: '/order/createPurchasePlan',
      method: 'POST',
      data:data
    })
  }
  // 内部接单
  export function createPurchasePlan2(data) {
    return request({
      url: '/order/createPurchasePlan2',
      method: 'POST',
      data:data
    })
  }
  // 请求订单列表
  export function getOrderList(query) {
    return request({
      url: '/order/getOrderList',
         method: 'get',
    params: query
    })
  }
